import React, { useEffect, useState } from 'react';
import { usePolicyContext } from '../usePolicyContext';
import { SingleFieldValidationSchemaGenerator } from './SingleFieldValidationSchemaGenerator';
import { DisplaySingleFields, eSingleFields } from '../state/eSingleFields';
import { ePolicyContextActionType } from '../actions/ePolicyContextActionType';
import { useUpdateOrderTimberHook } from 'API/order/useUpdateOrderHook';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { fieldToBody } from "../../../components/order/overview/EditTransactionPrice/fieldNameToThings";
import { EditSingleFieldController } from '../../../ui-toolkit/orders/components/EditSingleField/EditSingleFieldController';
import {
  eEditSingleFieldInputType
} from '../../../ui-toolkit/orders/components/EditSingleField/eEditSingleFieldInputType';

export interface IModalHandlerProps {
  savePage: () => Promise<any> | null;
  loadPage: () => Promise<void>;
}

export const ModalHandler: React.FC<IModalHandlerProps> = ({ savePage, loadPage }) => {
  const [state, dispatch] = usePolicyContext();

  const [, setShowCantSave] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const inputType =
    state.editingSingleFieldName === eSingleFields.loan_number
      ? eEditSingleFieldInputType.String
      : eEditSingleFieldInputType.Currency;

  useEffect(() => {
    if (state.isEditingSingleField) {
      const result = savePage();
      if (result) {
        result.then(() => {
          setShowDialog(true);
        });
      } else {
        setShowCantSave(true);
      }
    }
  }, [state.editingSingleFieldName, state.isEditingSingleField, savePage]);

  const { data } = useSelectCurrentOrder();

  useEffect(() => {
    dispatch({ type: ePolicyContextActionType.SetOrder, payload: data });
  }, [data, dispatch]);

  const { action: doOrderUpdate } = useUpdateOrderTimberHook();
  const doSubmit = async (value: any) => {
    await doOrderUpdate(state.order, { [fieldToBody[state.editingSingleFieldName]]: value });
    loadPage();
    return { message: '' };
  };

  const onClose = (type: ePolicyContextActionType.CloseEditSingleFieldAction) => () => {
    dispatch({ type });
    setShowDialog(false);
    setShowCantSave(false);
  };
  return (
    <>
      {state.isEditingSingleField && showDialog ? (
        <EditSingleFieldController
          displayLabel={DisplaySingleFields[state.editingSingleFieldName]}
          actions={{ onClose: onClose(ePolicyContextActionType.CloseEditSingleFieldAction), doSubmit }}
          inputType={inputType}
          value={state.order.transaction[state.editingSingleFieldName] || 0}
          validationSchema={SingleFieldValidationSchemaGenerator(
            state.order.transaction.transaction_category,
            state.editingSingleFieldName
          )}
        />
      ) : null}
    </>
  );
};
